module.exports = __webpack_public_path__ + "img/Ingles.9d039b49.png";